<template>
  <v-tabs
    v-model="activeTabData"
    :background-color="color"
    class="tabs"
    :icons-and-text="false"
    @change="onChange($event)"
  >
    <v-tab
    v-for="i in tabsNumber"
    :key="i"
    :href="`#tab-${i}`"
    >
      <slot :name="'tabTitle' + (i)"></slot>
    </v-tab>
    <v-tab-item
      v-for="i in tabsNumber"
      :key="i"
      :value="'tab-' + i"
    >
      <v-card
        flat
        tile
      >
        <slot :name="'tabContent' + (i)"></slot>
      </v-card>
    </v-tab-item>

  </v-tabs>
</template>

<script>
export default {
  props: {
    tabsNumber: {
      type: Number,
      default: 2,
    },
    activeTab: {
      type: String,
      default: 'tab-1',
    },
    color: {
      type: String,
      default: 'transparent',
    },
  },
  data() {
    return {
      activeTabData: this.activeTab,
    };
  },
  methods: {
    onChange(e) {
      this.$emit('change', e);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/variables.scss";

$tabs-border: 1px solid #D4D4D4;
$tabs-bg-color: #EEF3F5;

.tabs {
  .v-tabs-slider-wrapper .v-tabs-slider {
    color: rgba($black-color, 0.9);
  }
  .v-tab {
    width: 180px;
    padding: 6px 10px;
    justify-content: space-between;
    border-radius: 3px 3px 0 0;
    margin-right: 6px;
    background-color: $tabs-bg-color;
    color: $black-color;
    text-transform: none;
    font-weight: 700;
    font-size: 1.2rem;

    &::before {
      content: none;
    }

    &.v-tab--active {
      border: $tabs-border;
      border-bottom: 1px solid transparent;
      background-color: $white-color;
    }
  }

  .v-tabs-items {
    border: $tabs-border;
    padding: 10px 0 60px;
  }
}
</style>
